module.exports = __webpack_public_path__ + "f131a23938861922b5dea2f7c43fa169.svg";